// Importing React classes and functions from node modules
import React, { useState, useEffect } from "react";
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import parse from 'html-react-parser';
import { Link, useLocation } from "react-router-dom";
import { deleteHomeworks, getSelectedId, createHomeworks, getHomeworks, getSelectedId2, removeSelectedId, removeSelectedId2, getGroups, fetchCSRF } from "../data/repository";

// Functional Component for Navigation Bar
function AddHomework(props) {

    const [errorMessage, setErrorMessage] = useState(null);
    const [homework, setHomework] = useState("");
    const [homeworks, setHomeworks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [groups, setGroupsData] = useState([]);
    const [csrfToken, setCsrfToken] = useState(null);
    const location = useLocation();
    const groupNumber = location?.state?.groupNumber;

    let groupDetails;

    const group = groups.find((group) => group.id === groupNumber);

    if (group) {
        groupDetails = group.group;
    } else if (groupNumber === "5") {
        groupDetails = "All Students";
    } else {
        groupDetails = "Invalid group number";
    }


    var IFRAME_SRC = '//cdn.iframe.ly/api/iframe';
    var API_KEY = 'ec1627000e306b7c55174b';
    // var API_HOST = 'http://localhost:4000';
    var API_HOST = 'https://masrooracademyvic.com.au';

    // Load Homeworks, Announcements and user Details from DB.
    useEffect(() => {

        // Loads Homeworks from DB
        async function loadHomeworks() {
            const currentHomeworks = await getHomeworks();

            setHomeworks(currentHomeworks);
            setIsLoading(false);
        }

        // Loads User Details from DB
        async function loadGroupDetails() {
            const currentGroups = await getGroups();
            setGroupsData(currentGroups)
        }

        // Calls the functions above
        loadHomeworks();
        loadGroupDetails();
    }, []);

    // Handler for when textbox value changes
    const handleInputChange = (event, editor) => {
        const data = editor.getData();
        setHomework(data);
        setErrorMessage("");
    };

    // Call fetchCSRF and set token once
    if (!csrfToken) {
        fetchCSRF().then(setCsrfToken); // no useEffect
    }

    if (!csrfToken) {
        return <p className="text-center">Loading homework editor...</p>; // wait for token
    }

    const editorConfig = {
        simpleUpload: {
            uploadUrl: `${API_HOST}/MAApi/image/upload`,
            withCredentials: true,
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        },
        mediaEmbed: {
            previewsInData: true,
            providers: [
                {
                    // hint: this is just for previews. Get actual HTML codes by making API calls from your CMS
                    name: 'iframely previews',

                    // Match all URLs or just the ones you need:
                    // url: /.+/,
                    url: /^https?:\/\/(www\.)?(youtube\.com|twitter\.com|vimeo\.com|soundcloud\.com)\//,

                    html: match => {
                        const url = match[0];

                        var iframeUrl = IFRAME_SRC + '?app=1&api_key=' + API_KEY + '&url=' + encodeURIComponent(url);
                        // alternatively, use &key= instead of &api_key with the MD5 hash of your api_key
                        // more about it: https://iframely.com/docs/allow-origins

                        return (
                            // If you need, set maxwidth and other styles for 'iframely-embed' class - it's yours to customize
                            '<div class="iframely-embed" style="width: 100%">' +
                            '<div class="iframely-responsive">' +
                            `<iframe src="${iframeUrl}" ` +
                            'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' +
                            '</iframe>' +
                            '</div>' +
                            '</div>'
                        );
                    }
                }
            ]
        }
    }

    // Generic Form Submission Handler
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Trim the Homework text.
        const trimmedHomework = homework.trim();

        // Validation Code
        if (trimmedHomework === "") {
            setErrorMessage("Homework is Empty!");
            return;
        }

        // Create a Homework.
        const newHomework = { homeworkText: trimmedHomework, homeworkDate: new Date().toLocaleString, id: props.user.id, student: getSelectedId() };
        await createHomeworks(newHomework);

        // Update Page/Refresh the Data
        const currentHomeworks = await getHomeworks();
        setHomeworks(currentHomeworks);

        // Reset Homework content.
        setHomework("");
        setErrorMessage("");
    };

    const canDeletePost = (user, post) => {
        const isAdmin = user.group === "Admin";
        const isPostOwner = user.id === post.poster.id;
        const isMalePrincipal = user.group === "Principal" && user.gender === "Male";
        const isMaleVicePrincipal = user.group === "Vice Principal" && user.gender === "Male";
        const isFemaleVicePrincipal = user.group === "Vice Principal" && user.gender === "Female";
        const isFemalePrincipal = user.group === "Principal" && user.gender === "Female";
        const isMaleAdminStaff = user.group === "Admin Staff" && user.gender === "Male";
        const isFemaleAdminStaff = user.group === "Admin Staff" && user.gender === "Female";

        const postIsByMaleTeacher = post.poster.group === "Male Teacher";
        const postIsByFemaleTeacher = post.poster.group === "Female Teacher";
        const postIsByAdminStaff = post.poster.group === "Admin Staff";
        const postIsByPrincipal = post.poster.group === "Principal";
        const postIsByFemale = post.poster.gender === "Female";
        const postIsByMale = post.poster.gender === "Male";

        // Admin can delete any post
        if (isAdmin) return true;

        // Users can delete their own posts
        if (isPostOwner) return true;

        // Male Principal can delete all posts except Admin's
        if (isMalePrincipal) {
            return post.poster.group !== "Admin";
        }

        // Male Vice Principal can delete all posts except Male Principal's and Admin's
        if (isMaleVicePrincipal) {
            return !(post.poster.group === "Principal" && postIsByMale) && post.poster.group !== "Admin";
        }

        // Female Vice Principal can delete posts by all female users except Female Principal
        if (isFemaleVicePrincipal) {
            return postIsByFemale && !(postIsByPrincipal && postIsByFemale);
        }

        // Female Principal can delete posts by all female users
        if (isFemalePrincipal) {
            return postIsByFemale;
        }

        // Male Admin Staff can delete posts by Male Teachers and Male Admin Staff
        if (isMaleAdminStaff) {
            return postIsByMaleTeacher || (postIsByAdminStaff && postIsByMale);
        }

        // Female Admin Staff can delete posts by Female Teachers and Female Admin Staff
        if (isFemaleAdminStaff) {
            return postIsByFemaleTeacher || (postIsByAdminStaff && postIsByFemale);
        }

        // Male and Female Teachers can only delete their own posts (already covered by isPostOwner)

        return false;
    };

    // Returns HTML code from this function which is displayed by importing on other pages
    return (

        <div>
            <p>&nbsp;</p>
            <form onSubmit={handleSubmit} >
                <div className="form-group">
                    <h3 className="text-center">Add Homework for Student {getSelectedId2()}</h3>
                    <h5 className="text-center"> Please Delete the Previous Homework Once it is Completed!</h5>
                    <div className="richTextEditor">
                        <CKEditor editor={Editor} data={homework} onChange={handleInputChange} config={editorConfig} />
                    </div>
                </div>
                {errorMessage && (
                    <p style={{ color: "red", textAlign: "center", fontSize: "18px", margin: "10px 10px 10px 10px" }}>{errorMessage}</p>
                )}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" style={{ margin: "5px", padding: "5px 25px 5px 25px" }} className="text-center btn btn-outline-primary2" >Add</button>
                    <button type="button" style={{ margin: "5px " }} className="text-center btn btn-outline-danger" onClick={() => { setHomework(""); setErrorMessage(null); }} >Clear</button>
                    <Link to={`/HomeworkGroup/${groupNumber}`}>
                        <button type="button" style={{ margin: "5px" }} className="text-center btn btn-success" onClick={() => { setHomework(""); setErrorMessage(null); removeSelectedId2(); removeSelectedId(); }} >Go Back to {groupDetails}</button>
                    </Link>
                </div>
            </form>
            <p>&nbsp;</p>

            {isLoading ?
                <div className="card-body text-center">
                    <span className="text-muted">Loading Homework...</span>
                </div>
                :
                <>
                    {homeworks.filter(homeworkPosts => homeworkPosts.student === getSelectedId()).length === 0 ?
                        <div className="text-center">
                            <span className="text-muted">No Homework have been Posted!</span>
                            <p>&nbsp;</p>
                        </div>
                        :
                        <>
                            {homeworks.filter(homeworkPosts => homeworkPosts.student === getSelectedId()).map((homeworkPosts) =>
                                <div key={homeworkPosts.homeworkPosts_id}>
                                    <div className="postedContent card" style={{ minWidth: "50%", overflowX: "auto" }}>
                                        <div className="card-body">
                                            <h5 style={{ float: "left", textAlign: "center", color: "#112c3f" }} className="card-title">
                                                {homeworkPosts.poster.gender === "Female" && homeworkPosts.poster.group === "Principal" ?
                                                    `${homeworkPosts.poster.name} - In Charge Girls Section`
                                                    : homeworkPosts.poster.gender === "Female" && homeworkPosts.poster.group === "Vice Principal" ?
                                                        `${homeworkPosts.poster.name} - Vice In Charge Girls Section`
                                                        : `${homeworkPosts.poster.name} - ${homeworkPosts.poster.group}`}
                                            </h5>
                                            <span style={{ float: "right", textAlign: "center", color: "#212121" }}>{new Date(homeworkPosts.homeworkDate).toLocaleString("en-AU", { hour12: true, hour: 'numeric', minute: 'numeric', day: "numeric", month: "short", year: "numeric" })}</span>
                                            <div className="post-body">
                                                <pre className="postStyle card-text" style={{ whiteSpace: 'pre-wrap' }}>{parse(homeworkPosts.homeworkText)}</pre>


                                                {canDeletePost(props.user, homeworkPosts) && (
                                                    <div>
                                                        <button type="submit" style={{ float: "right", textAlign: "right" }} className="btn btn-danger mr-sm-2" onClick={async () => { await deleteHomeworks(homeworkPosts); setHomeworks(await getHomeworks()); }} >Delete</button>
                                                    </div>

                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <p>&nbsp;</p>
                                </div>
                            )}
                        </>
                    }
                </>
            }
            <p>&nbsp;</p>
        </div>
    );
}

// Export the Navigation Function
export default AddHomework;